export default "__VITE_ASSET__h87QsxYk__"